import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Stack } from '@mui/material'
import React, { useState } from 'react'

import { registerKiosk } from '../../services/KioskService'

const KioskRegisterModal = ({ open, onClose, onRegisterSuccess }) => {
    const [errors, setErrors] = useState({})
    const [responseMessage, setResponseMessage] = useState('')
    const [showResponseDialog, setShowResponseDialog] = useState(false)
    const [newKiosk, setNewKiosk] = useState({})

    const validateFields = () => {
        const newErrors = {}
        const requiredFields = ['name', 'location']

        requiredFields.forEach((field) => {
            if (!newKiosk[field]) {
                newErrors[field] = 'This field is required'
            }
        })

        setErrors(newErrors)
        return Object.keys(newErrors).length === 0
    }

    const handleRegisterInputChange = (e) => {
        const { name, value } = e.target

        setNewKiosk((prev) => ({ ...prev, [name]: value }))
    }

    const handleFormSubmit = async (event) => {
        event.preventDefault()

        if (validateFields()) {
            try {
                const result = await registerKiosk(newKiosk)

                if (result.error) {
                    setResponseMessage(result.error)
                } else {
                    setResponseMessage(result.message || `Kiosk ${result.kiosk?.kioskCode} has been registered`)
                    setNewKiosk({})
                    onRegisterSuccess()
                }
                setShowResponseDialog(true)
            } catch (error) {
                setResponseMessage('An error occurred while registering the kiosk.')
                setShowResponseDialog(true)
            } finally {
                onClose()
            }
        }
    }

    return (
        <>
            <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
                <DialogTitle>Register Kiosk</DialogTitle>
                <DialogContent>
                    <form onSubmit={handleFormSubmit}>
                        <Stack spacing={3} style={{ marginTop: '16px' }}>
                            <TextField
                                margin="normal"
                                name="name"
                                label="Kiosk Name"
                                fullWidth
                                variant="outlined"
                                value={newKiosk.name || ''}
                                onChange={handleRegisterInputChange}
                                error={Boolean(errors.name)}
                                helperText={errors.name}
                            />

                            <TextField
                                margin="normal"
                                name="location"
                                label="Location"
                                fullWidth
                                variant="outlined"
                                value={newKiosk.location || ''}
                                onChange={handleRegisterInputChange}
                                error={Boolean(errors.location)}
                                helperText={errors.location}
                            />
                        </Stack>

                        <DialogActions style={{ marginTop: '16px' }}>
                            <Button onClick={onClose} color="secondary">
                                Cancel
                            </Button>
                            <Button type="submit" color="primary" variant="contained">
                                Register
                            </Button>
                        </DialogActions>
                    </form>
                </DialogContent>
            </Dialog>

            {/* Response Dialog */}
            <Dialog open={showResponseDialog} onClose={() => setShowResponseDialog(false)}>
                <DialogTitle>Response</DialogTitle>
                <DialogContent>
                    <p>{responseMessage}</p>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setShowResponseDialog(false)} color="primary">
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default KioskRegisterModal
